import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-80 flex justify-center items-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex justify-between pt-4 px-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0.2rem","text-transform":"uppercase"} }, "Course", -1)
const _hoisted_5 = { class: "text-4xl mb-3 font-bold tracking-tight text-gray-900" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-book" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Create or edit a course", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Course setup", -1)
const _hoisted_10 = {
  key: 0,
  class: "p-4"
}
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Is active", -1)
const _hoisted_13 = { class: "col-sm-8 flex items-center gap-2" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Is mandatory", -1)
const _hoisted_16 = { class: "col-sm-8 flex flex-col" }
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "max-w-xl" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", null, "or", -1)
const _hoisted_21 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Is mandatory for positions", -1)
const _hoisted_23 = { class: "col-sm-8 max-w-2xl" }
const _hoisted_24 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Is mandatory for idam roles", -1)
const _hoisted_26 = { class: "col-sm-8 max-w-2xl" }
const _hoisted_27 = { class: "row mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Search tags", -1)
const _hoisted_29 = { class: "col-sm-8" }
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Title", -1)
const _hoisted_32 = { class: "col-sm-8" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Description", -1)
const _hoisted_35 = { class: "col-sm-8" }
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Image URL", -1)
const _hoisted_38 = { class: "col-sm-8" }
const _hoisted_39 = { class: "row mb-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Sub topic", -1)
const _hoisted_41 = { class: "col-sm-8" }
const _hoisted_42 = { class: "row mb-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Force users to retake the course", -1)
const _hoisted_44 = { class: "col-sm-8 flex items-center gap-2" }
const _hoisted_45 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Should retake/revisit course after", -1)
const _hoisted_47 = { class: "col-sm-8 flex items-center gap-2" }
const _hoisted_48 = { class: "row mb-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Certificate", -1)
const _hoisted_50 = { class: "col-sm-8 max-w-2xl" }
const _hoisted_51 = { class: "row mb-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Folder", -1)
const _hoisted_53 = { class: "col-sm-8" }
const _hoisted_54 = { class: "relative max-w-2xl" }
const _hoisted_55 = { class: "row mb-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-12 col-form-label" }, "Who can see course (IDAM 2.0)", -1)
const _hoisted_57 = { class: "col-sm-12 flex justify-end w-full" }
const _hoisted_58 = { class: "max-w-3xl w-full" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-graduation-cap mr-2" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", null, "Lessons in course", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TreeSelect = _resolveComponent("TreeSelect")!
  const _component_IdamSegmentator = _resolveComponent("IdamSegmentator")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_CourseLessons = _resolveComponent("CourseLessons")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($data.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loading, { text: "Fetching course" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createElementVNode("h2", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString($data.course?.title), 1)
                ])
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                onClick: $options.saveCourse,
                icon: "fa-solid fa-floppy-disk",
                label: "Save",
                loading: $data.saveLoading
              }, null, 8, ["onClick", "loading"])
            ])
          ]),
          _createVNode(_component_TabView, null, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  ($data.course)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_InputSwitch, {
                              modelValue: $data.course.isActive,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.course.isActive) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$filters.boolYesNo($data.course.isActive)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_InputSwitch, {
                                modelValue: $data.course.isMandatory,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.course.isMandatory) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", null, _toDisplayString(_ctx.$filters.boolYesNo($data.course.isMandatory)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              ($data.course.isMandatory)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_19, [
                                    _createTextVNode(" User must have either one of the specified positions "),
                                    _hoisted_20,
                                    _createTextVNode(" one of the specified idam roles ")
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            ($data.course.isMandatory)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_MultiSelect, {
                                      modelValue: $data.course.mandatoryPositions,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.course.mandatoryPositions) = $event)),
                                      options: _ctx.positions,
                                      optionLabel: "name",
                                      optionValue: "id",
                                      placeholder: "Positions this course is mandatory for",
                                      class: "w-full max-w-2xl",
                                      filter: "",
                                      showClear: "",
                                      multiple: "",
                                      loading: !_ctx.positions || _ctx.positions.length == 0
                                    }, null, 8, ["modelValue", "options", "loading"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            ($data.course.isMandatory)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _hoisted_25,
                                  _createElementVNode("div", _hoisted_26, [
                                    _createVNode(_component_MultiSelect, {
                                      modelValue: $data.course.mandatoryIdamRoles,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.course.mandatoryIdamRoles) = $event)),
                                      options: _ctx.userQueryInfo?.allRoles.map(r => ({ id: r.id, name: r.name + ' (' + r.id + ')' })),
                                      optionLabel: "name",
                                      optionValue: "id",
                                      placeholder: "Idam roles this course is mandatory for",
                                      class: "w-full max-w-2xl",
                                      filter: "",
                                      showClear: "",
                                      multiple: "",
                                      loading: _ctx.userQueryInfo?.allRoles == null || _ctx.userQueryInfo.allRoles.length == 0
                                    }, null, 8, ["modelValue", "options", "loading"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_Chips, {
                              modelValue: $data.course.searchTags,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.course.searchTags) = $event)),
                              allowDuplicate: false,
                              placeholder: "Enter search tags",
                              class: "!block"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_InputText, {
                              modelValue: $data.course.title,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.course.title) = $event)),
                              class: "w-full",
                              placeholder: "Title"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_Textarea, {
                              modelValue: $data.course.description,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.course.description) = $event)),
                              class: "w-full",
                              autoResize: "",
                              placeholder: "Description"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_InputText, {
                              modelValue: $data.course.imageUrl,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.course.imageUrl) = $event)),
                              class: "w-full",
                              placeholder: "Image url for the course"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_InputText, {
                              modelValue: $data.course.subTopic,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.course.subTopic) = $event)),
                              class: "w-full",
                              placeholder: "Sub topic"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_InputSwitch, {
                              modelValue: $data.course.hasRetakeTimer,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.course.hasRetakeTimer) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$filters.boolYesNo($data.course.hasRetakeTimer)), 1)
                          ])
                        ]),
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            ($data.course.hasRetakeTimer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_component_InputNumber, {
                                      modelValue: $data.course.retakeTimer,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.course.retakeTimer) = $event)),
                                      class: "w-full",
                                      suffix: " days"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_Dropdown, {
                              modelValue: $data.course.certificateId,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.course.certificateId) = $event)),
                              options: _ctx.certificates,
                              optionLabel: "title",
                              optionValue: "id",
                              placeholder: "Select a certificate to be issued upon completion",
                              class: "w-full max-w-2xl",
                              filter: "",
                              showClear: "",
                              loading: !_ctx.certificates || _ctx.certificates.length == 0
                            }, null, 8, ["modelValue", "options", "loading"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_TreeSelect, {
                                modelValue: $options.folderNode,
                                "onUpdate:modelValue": $options.onNodeSelect,
                                selectionMode: "single",
                                options: $options.buildFolderNodeTree(),
                                placeholder: "Select which folder this course appears in",
                                class: "w-full",
                                showClear: "",
                                loading: !_ctx.folders || _ctx.folders.length == 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "loading"]),
                              (this.course.folderId != null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "pi pi-times text-gray-500 cursor-pointer absolute right-12 top-1/2 -mt-2",
                                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (this.course.folderId = null), ["stop"]))
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_IdamSegmentator, {
                                modelValue: $data.course.userQuery,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.course.userQuery) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _hoisted_59,
                  _hoisted_60
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_CourseLessons, {
                    courseLessons: $data.course.lessons,
                    "onUpdate:courseLessons": _cache[14] || (_cache[14] = ($event: any) => (($data.course.lessons) = $event)),
                    courseId: $data.course.id,
                    class: "mt-4"
                  }, null, 8, ["courseLessons", "courseId"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
  ]))
}